import request from '@/utils/request';

export function getApplicant(id) {
  return request({
    url: `/applicants/${id}`,
    method: 'get',
  });
}

export function createApplicant(query) {
  return request({
    url: '/applicants',
    method: 'post',
    data: query,
  });
}

export function updateApplicant(query) {
  return request({
    url: `/applicants/${query.id}`,
    method: 'patch',
    data: query,
  });
}

export function applicantLogin(account) {
  return request({
    url: '/applicants/login',
    method: 'get',
    params: account,
  });
}
